import React, { useState, useEffect } from "react";

// import { PercentInputWithLabel } from "../../../Components/Input";
import { formatMoney } from "../../../utils/money";
import { getTotalDiscount } from "../../../utils/discount";
import { getTranslateByScope } from "../../../i18n";

import "./SetDiscount.scss";

function SetDiscount(props) {
  const translate = getTranslateByScope("app.setDiscount");
  const order = props.order;
  const total = props.total;
  const currency = props.currency ?? "EUR";

  const [discount1, setDiscount1] = useState(
    order.discount1 ?? order.discountA,
  );
  const [discount2, setDiscount2] = useState(
    order.discount2 ?? order.discountB,
  );
  const [discount3, setDiscount3] = useState(
    order.discount3 ?? order.discountC,
  );

  useEffect(() => {
    const totalDiscount = getTotalDiscount(discount1, discount2, discount3);
    const discounts = {
      a: discount1,
      b: discount2,
      c: discount3,
      total: totalDiscount,
    };

    console.log("updating discount");

    props.updateDiscount(discounts);

    // react complains that we're not including props.updateDiscount in our
    // useEffect dependencies, if we add this we will rerender in a loop
    // if we add this to a useCallback we get weird sync issues
    // eslint-disable-next-line
  }, [discount1, discount2, discount3]);

  let discount = order.discount;

  if (discount === null || discount === undefined) {
    discount = 0;
  }

  const original = total ?? 0;
  const amountAfter1 = total * (1 - discount1 / 100.0);
  const discountAmount1 = original - amountAfter1;
  const totalDiscount1 = getTotalDiscount(discount1, 0, 0);

  const amountAfter2 = amountAfter1 * (1 - discount2 / 100.0);
  const discountAmount2 = amountAfter1 - amountAfter1;
  const totalDiscount2 = getTotalDiscount(discount1, discount2, 0);

  const amountAfter3 = amountAfter2 * (1 - discount3 / 100.0);
  const discountAmount3 = amountAfter2 - amountAfter3;
  const totalDiscount3 = getTotalDiscount(discount1, discount2, discount3);

  const setDiscountCallback = (setter, e) => {
    let v = e.target.value;
    if (v === undefined || v === "" || isNaN(v) || v < 0 || v > 100) {
      v = 0;
    }

    v = parseInt(v);
    setter(v);
  };

  return (
    <div>
      <table className="discountTable">
        <thead>
          <tr>
            <th>{translate("before")}</th>
            <th>{translate("discount")}</th>
            <th>{translate("after")}</th>
            <th>{translate("amount")}</th>
            <th>{translate("total")}</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>{formatMoney(original, currency)}</td>
            <td className="qsEdit">
              <input
                className="inlineInput"
                value={discount1}
                onChange={(v) => {
                  setDiscountCallback(setDiscount1, v);
                }}
              />
              %
            </td>
            <td>{formatMoney(amountAfter1, currency)}</td>
            <td>{formatMoney(discountAmount1, currency)}</td>
            <td>{totalDiscount1}%</td>
          </tr>
          <tr>
            <td>{formatMoney(amountAfter1, currency)}</td>
            <td className="qsEdit">
              <input
                className="inlineInput"
                value={discount2}
                onChange={(v) => {
                  setDiscountCallback(setDiscount2, v);
                }}
              />
              %
            </td>
            <td>{formatMoney(amountAfter2, currency)}</td>
            <td>{formatMoney(discountAmount2, currency)}</td>
            <td>{totalDiscount2}%</td>
          </tr>
          <tr>
            <td>{formatMoney(amountAfter2, currency)}</td>
            <td className="qsEdit">
              <input
                className="inlineInput"
                value={discount3}
                onChange={(v) => {
                  setDiscountCallback(setDiscount3, v);
                }}
              />
              %
            </td>
            <td>{formatMoney(amountAfter3, currency)}</td>
            <td>{formatMoney(discountAmount3, currency)}</td>
            <td>{totalDiscount3}%</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default SetDiscount;
